import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/storefront/format-resource';

const GiftCardPrice = ({ price }) => (
  <>
    <span>{formatMoney(price)}</span>
  </>
);

export default GiftCardPrice;
